import Styles from './styles.module.css';
import React from 'react';
import Icon from "./../../../image/icon_black.png";

const AuthHeader: React.FC = () => {

  return (
    <>
    <div className={Styles.box}>

      <a href="https://memorii-works.com" target="_blank" rel="noopener noreferrer">
        <img className={Styles.logo} src={Icon} alt='ロゴ' />
      </a>

      <a href="https://memorii-works.com/contact" target="_blank" rel="noopener noreferrer">
        <p className={Styles.contact}>お問い合わせ</p>
      </a>
      
    </div>
    </>
  );
}

export default AuthHeader;
